import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { MenuServices } from "../../../services";
import { DishServices } from "../../../../dish/services";
import { Globals } from "../../../../../globals";

/**
 * Generated class for the MenuPartialCustomizeViewA5Page page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-menu-partial-customize-view-a5',
    templateUrl: 'menu-partial-customize-view-a5.html',
})
export class MenuPartialCustomizeViewA5Page {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public menuServices: MenuServices,
        public globals: Globals,
        public dishServices: DishServices) {
    }

    setStylesP(section) {
        let styles = {
            'text-align': section.text_align,
            'font-family': section.font_family,
            'color': section.font_color,
            'word-wrap': 'break-word',
            'margin-bottom': '0px',
        };
        return styles;
    }

    setStylesSpan(section) {
        let styles = {
            'font-size': section.font_size + 'px',
        };
        return styles;
    }

    styleA4H(menu) {
        //Simulacion de la hoja de papel A4. Propocionalmente le ponemos la medida
        var width_div = document.getElementById('paper_sheetA4H').offsetWidth;
        //Regla de 3 para encontrar la parte propocional para tener un A4 en pantalla.
        var base_width = 841.89; //A4
        var base_height = 595.276; //A4
        var percent = width_div * 100 / base_width;
        var height_div = base_height * percent / 100;
        let styles = {
            'height': height_div + 'px',
            'background-position': 'center',
            'background-repeat': 'no-repeat',
            '-webkit-background-size': 'cover',
            '-moz-background-size': 'cover',
            '-o-background-size': 'cover',
            'background-size': 'cover',
        };

        return styles;

    }

    styleA5(menu) {
        //Simulacion de la hoja de papel A4. Propocionalmente le ponemos la medida
        var width_div = document.getElementById('paper_sheetA5').offsetWidth;
        //Regla de 3 para encontrar la parte propocional para tener un A4 en pantalla.
        var base_width = 595.276; //A4
        var base_height = 841.89; //A4
        var percent = width_div * 100 / base_width;
        var height_div = base_height * percent / 100;
        let styles = {
            'height': height_div + 'px',
            'background-position': 'center',
            'background-repeat': 'no-repeat',
            '-webkit-background-size': 'cover',
            '-moz-background-size': 'cover',
            '-o-background-size': 'cover',
            'background-size': 'cover',
        };

        return styles;

    }

    setStylesHeaderTitle(menu) {
        let styles = {
            'text-align': menu.header_text_align,
            'font-family': menu.header_font_family,
            'color': menu.header_font_color,
            'font-size': menu.header_font_size + 'px',
            'word-wrap': 'break-word',
            'margin-bottom': '0px',
        };
        return styles;
    }
    setStylesHeaderSubTitle(menu) {
        var _size = menu.header_font_size - 8;
        let styles = {
            'text-align': menu.header_text_align,
            'font-family': menu.header_font_family,
            'color': menu.header_font_color,
            'font-size': _size + 'px',
            'word-wrap': 'break-word',
        };
        return styles;
    }

    setStyleFont(size) {
        let styles = {
            'font-size': size + 'px',
        };
        return styles;
    }

    setStylesFooter(menu) {
        let styles = {
            'text-align': menu.footer_text_align,
            'font-family': menu.footer_font_family,
            'color': menu.footer_font_color,
            'font-size': menu.footer_font_size + 'px',
            'word-wrap': 'break-word',
            'margin-bottom': '0px',
        };
        return styles;
    }

}


// WEBPACK FOOTER //
// ./src/pages/menu/menu-view/menu-partial-customize-view/menu-partial-customize-view-a5/menu-partial-customize-view-a5.ts